/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

// atagon GmbH
// Generated API client for States
// Do not change it manually; use the Code Generator plugin instead. (Look at the code of the server providing the api)


import {fetchProxy} from "../APIClient.jsx";

export const StatesAPI = function () {

    function getStateHistory(name, elementId, limit) {
        let parameter = {}
        parameter.name = name;
        parameter.elementId = elementId;
        parameter.limit = limit;
        return fetchProxy("states/getStateHistory", parameter)
    }

    function getCurrentState(name, elementId) {
        let parameter = {}
        parameter.name = name;
        parameter.elementId = elementId;
        return fetchProxy("states/getCurrentState", parameter)
    }


    return {
        getStateHistory,
        getCurrentState
    }
}()